


































































/* eslint-disable class-methods-use-this */
import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import store from '@/store';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
  },
})

export default class UserProfile extends Vue {
  @Prop(String) statusBoarding!: string;
  value = 0;
  step = 0

  @Prop(Number) channels!: number;

  enableBusinessInformation = true;

  data = JSON.parse(localStorage.getItem('USER') || '{}');

  mounted() {
    this.enableBusinessInformation = store.state.user?.user.merchant?.status === 'INACTIVE';
  }

  toggleModal() {
    if (this.channels) {
      this.$router.push('/integration');
    } else {
      this.$emit('toggleModal');
    }
  }

  merchant() {
    if (this.enableBusinessInformation) {
      this.$router.push('/bussinesaccount/bussinesinformation');
    }
  }

  @Watch('statusBoarding')
  check() {
    if (this.statusBoarding === 'true') {
      this.value += 50;
      this.step += 1;
    }
  }

  @Watch('channels')
  checks() {
    if (this.channels > 0) {
      this.value += 50;
      this.step += 1;
    }
  }
}
